import { useMemo, useState } from 'react';
import { ToothSurface } from '../../../../../graphql/graphql';
import { PATHOLOGY_ITEMS_SURFACES } from '../../../Components/DENTModalOverviewPathology/pathologyItemsSurfaces';
import { useDENTContext } from '../../../Services/DENTContext';
import useTooth from '../useTooth';
import { SurfaceOperation } from '../../../Enums/SurfaceOperation.enum';
import { SurfaceHandler } from '../../../Interfaces/SurfaceHandler.interface';
import { SurfaceBasedToothWearType } from '../../../Components/DENTModalOverviewPathologyButtons/DENTModalOverviewPathologyToothWear';
import { TOOTH_WEAR_SURFACES_CONFIG } from '../../../Helpers/toothWear/toothWearSurfaces.config';

const EMPTY_SURFACE_HANDLER: SurfaceHandler = {
	showedSurfaces: [],
	selectedSurfaces: [],
	handleSelectSurface: () => {},
	shouldShowSurfaces: false,
};

export default function useToothWearSurfaceHandler(
	toothWearType?: SurfaceBasedToothWearType,
): SurfaceHandler {
	const { activeTooth } = useDENTContext();
	const {
		pathology: { toothWear },
	} = useTooth();

	const config = toothWearType
		? TOOTH_WEAR_SURFACES_CONFIG[toothWearType]
		: undefined;
	const wearSlice = config ? toothWear[config.key] : undefined;

	const showedSurfaces = config
		? PATHOLOGY_ITEMS_SURFACES[config.pathologyItem]
		: [];

	const selectedSurfaces = useMemo(() => {
		return wearSlice?.surfaces ?? [];
	}, [wearSlice, activeTooth]);

	const [shouldShowSurfaces, setShouldShowSurfaces] = useState(false);

	const handleSelectSurface = (
		surfaces: ToothSurface[],
		operation: SurfaceOperation,
	) => {
		wearSlice?.setSurfaces(surfaces, operation);
	};

	if (!config) {
		return EMPTY_SURFACE_HANDLER;
	}

	return {
		showedSurfaces,
		selectedSurfaces,
		handleSelectSurface,
		shouldShowSurfaces,
		setShouldShowSurfaces,
	} as SurfaceHandler;
}
